/**
 * Rueckfrage bei wiederkehrenden Aufgaben (F-24): "nur dieses Mal / dieses
 * und folgende / alle". Ein Dialog fuer die ganze App, eingehaengt in der
 * Huelle - so braucht keine Liste eigenen Dialogzustand.
 */
import { create } from 'zustand';

import { db } from '@/db/schema';
import { deleteTask } from '@/db/repositories/tasks';
import { serieLoeschen } from '@/db/repositories/aufgabenSerie';
import type { ID, RecurrenceEditScope } from '@/domain/types';

interface Frage {
  mode: 'bearbeiten' | 'loeschen';
  ohneEinzeln: boolean;
  antwort: (scope: RecurrenceEditScope | null) => void;
}

export const useSerienFrage = create<{ frage: Frage | null }>()(() => ({ frage: null }));

/** Fragt nach dem Umfang; `null` heisst abgebrochen. */
export function serieFragen(mode: Frage['mode'], ohneEinzeln = false): Promise<RecurrenceEditScope | null> {
  return new Promise((resolve) => {
    useSerienFrage.setState({
      frage: { mode, ohneEinzeln, antwort: (s) => { useSerienFrage.setState({ frage: null }); resolve(s); } },
    });
  });
}

/** Loeschen aus jeder Liste: bei einer Serie mit Rueckfrage. */
export async function aufgabeLoeschen(id: ID): Promise<void> {
  const t = await db.tasks.get(id);
  if (!t?.wiederholung) {
    await deleteTask(id);
    return;
  }
  const scope = await serieFragen('loeschen');
  if (scope) await serieLoeschen(id, scope);
}
